import { createPortal } from 'react-dom';
import { RefreshCw } from 'lucide-react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { useToastLayout } from '../state/ToastProvider';

/** Meldt dat er een nieuwe versie klaarstaat en laadt die na een tik. Alleen in productie actief. */
export function UpdateToast() {
  const { bottomPx } = useToastLayout();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      if (!registration) return;
      // Controleer op een nieuwe versie bij starten, bij terugkeren naar de app, zodra de verbinding terug is en elk uur.
      const check = () => {
        if (navigator.onLine) registration.update().catch(() => {});
      };
      check();
      document.addEventListener('visibilitychange', () => document.visibilityState === 'visible' && check());
      window.addEventListener('online', check);
      setInterval(check, 60 * 60 * 1000);
    },
  });

  if (!needRefresh) return null;

  // Boven de timerbalk en de gewone meldingen (z-130): 64px extra ruimte voor een zichtbare toast.
  return createPortal(
    <div
      role="status"
      className="fixed left-1/2 z-[150] flex -translate-x-1/2 items-center gap-3 rounded-2xl bg-slate-900 py-2 pl-4 pr-2 text-sm font-semibold text-slate-50 shadow-2xl dark:bg-slate-100 dark:text-slate-900"
      style={{ bottom: `calc(env(safe-area-inset-bottom, 0px) + ${bottomPx + 64}px)` }}
    >
      <RefreshCw className="h-4 w-4 shrink-0" aria-hidden />
      <span className="whitespace-nowrap">Nieuwe versie beschikbaar</span>
      <button
        type="button"
        onClick={() => updateServiceWorker(true)}
        className="min-h-11 whitespace-nowrap rounded-xl bg-sky-700 px-4 text-white transition-all duration-150 active:scale-95"
      >
        Nu vernieuwen
      </button>
      <button
        type="button"
        onClick={() => setNeedRefresh(false)}
        className="min-h-11 whitespace-nowrap rounded-xl px-3 text-slate-300 transition-all duration-150 active:scale-95 dark:text-slate-600"
      >
        Later
      </button>
    </div>,
    document.body,
  );
}
